'use client'

import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Paper, Button, Container, List, ListItem, ListItemText } from '@mui/material';
import { getDictionary, getField } from '../../utils/translation/translation';
import { getSvg } from '../../utils/svgUtils';
import './style.css'
import { useRouter } from 'next/navigation';
import useTranslations from '../../hooks/useTranslation';
import useIsMobile from '../../hooks/useIsMobile';
import { useNavbar } from '../../contexts/NavbarContext';

export default function AboutUs() {
    const {
        loading,
        translations,
        supportedLanguages,
        language,
        selectedLanguage,
        handleLanguageChange,
    } = useTranslations();
    const isMobile = useIsMobile();
    const { contactusRef, scrollToSection } = useNavbar();
    const phoneNumber = '+971501286691';
    const isArabic = language === 'arabic';
    const dictionary = getDictionary(translations, 'about-us', language);

    return (
        <>
            {/* first section */}
            <div style={{ marginTop: isMobile ? "6rem" : "10rem", minHeight: 400, width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Grid container spacing={!isMobile && isArabic ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "25px"} marginTop={"2.6rem"}>
                    <Grid item xs={12} sm={6} md={7} style={{ order: isArabic ? 2 : 1 }}>
                        <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <Typography gutterBottom component="h1" variant="h1" fontWeight="bold" fontFamily="Century Gothic" fontSize={"25px"}>
                                {getField(dictionary, 'about-us', language)}
                                <br />
                                {getField(dictionary, 'title1', language)}
                            </Typography>
                            {getSvg('arrowUpIcon', { mainPurple: 'var(--accent-primary)' }, { width: '70px', height: '70px' }, { minWidth: 70, minHeight: 70 })}
                            <Typography paragraph component="h2" variant="h2" fontWeight={"bold"} fontFamily="Century Gothic" fontSize={"15px"} sx={{ color: "var(--text-primary)" }}>
                                {getField(dictionary, 'description1', language)}
                            </Typography>
                            <Button
                                variant='contained'
                                sx={{
                                    backgroundColor: "var(--accent-primary)",
                                    marginTop: "10px",
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: "var(--accent-secondary)",
                                    },
                                }}
                            >
                                <a onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: "white" }}>
                                    {getField(dictionary, 'button1', language)}
                                </a>

                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={5} style={{ order: !isMobile && isArabic ? 1 : 2, }}>
                        <Box display="flex" justifyContent="center">
                            {getSvg('about1Icon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: isMobile ? 240 : 350, height: isMobile ? 240 : 350 }, { minWidth: isMobile ? 240 : 350, minHeight: isMobile ? 240 : 350 })}
                        </Box>
                    </Grid>

                </Grid >
            </div>
            {/* end of first section */}


            {/* second section  */}
            <div style={{ width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ marginTop: "50px" }}>
                    <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"} >
                        <Grid item xs={12} md={6} >
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <div >
                                    <div style={{ position: 'relative', zIndex: 0 }}>
                                        <Typography paragraph fontWeight="bold" fontSize={isMobile ? "20px" : "25px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                            {getField(dictionary, 'title2', language)}
                                        </Typography>
                                    </div>
                                    <div style={{ position: 'relative', zIndex: -1 }}>
                                        {getSvg('arrowCircleIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 80, height: 80 }, { position: 'absolute', minWidth: 80, minHeight: 80, transform: isArabic ? "translate(-5rem , -5rem)" : isMobile ? "translate(4rem , -5rem)" : "translate(6rem , -5rem)" })}
                                    </div>
                                </div>

                                <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'who-we-are', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>

                                </List>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-secondary)",
                                        color: "black",
                                        marginTop: "10px",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-primary)",
                                        },
                                    }}
                                >
                                    <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'black', fontSize: '15px' }}>
                                        {getField(dictionary, 'button2', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>

                        {!isMobile && (
                            <Grid item xs={12} md={6} >
                                <Box display="flex" justifyContent="center">
                                    {getSvg('about2Icon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 350, height: 250 }, { minWidth: 200, minHeight: 150 })}
                                </Box>
                            </Grid>
                        )}

                        {isMobile && (
                            <Grid item xs={12} md={6} >
                                <Box display="flex" justifyContent="center">
                                    {getSvg('about2Icon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 200, height: 150 }, { maxWidth: '100%', borderRadius: '10px', minWidth: 150, minHeight: 100 })}
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </div>
            {/* end of second section */}


            {/* third section */}
            <div style={{ marginTop: "20px" }}>
                <Grid container spacing={isMobile ? 2 : 4} alignItems="center" justifyContent="center" padding={isMobile ? "0px " : "30px"} className="section-light-purple-bg">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "85%", flexDirection: isMobile ? "column" : "row" }}>
                        {!isMobile && (<>
                            <Grid item xs={12} md={6}>
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about3.png`} loading="lazy" width={300} height={200} alt='supercharge' style={{ minWidth: 200, minHeight: 150 }} />
                                </Box>
                            </Grid>
                        </>)}

                        <Grid item xs={12} md={6}>
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <div >
                                    <div style={{ position: 'relative', zIndex: 0 }}>
                                        <Typography paragraph fontWeight="bold" fontSize={"25px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                            {getField(dictionary, 'title3', language)}
                                        </Typography>
                                    </div>
                                    <div style={{ position: 'relative', zIndex: -1 }}>
                                        {getSvg('doubleLinesIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 80, height: 20 }, { position: 'absolute', minWidth: 80, minHeight: 20, transform: isArabic ? "translate(-10rem , -1rem)" : "translate(4rem , -1rem)" })}
                                    </div>
                                </div>
                                <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'description3', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                </List>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-primary)",
                                        color: "white",
                                        marginTop: "30px",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-primary)",
                                        },
                                    }}
                                >
                                    <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                                        {getField(dictionary, 'button3', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>
                        {isMobile && (<>
                            <Grid item xs={12} md={6} justifyContent={'center'}>
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about3.png`} loading="lazy" width={200} height={150} alt='supercharge' style={{ minWidth: 150, minHeight: 100 }} />
                                </Box>
                            </Grid>
                        </>)}
                    </div>


                </Grid>
            </div>
            {/* end of third section */}

            {/* section 4  */}
            <div style={{ width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ marginTop: "20px" }}>
                    <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"}>
                        <Grid item xs={12} md={7} >
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <div style={{ position: 'relative', zIndex: -1 }}>
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/arrow.png`} loading="lazy" alt="Arrow Circle" width={80} height={80} style={{ position: 'absolute', minWidth: 80, minHeight: 80, transform: isArabic ? "translate(-9rem , -3rem)" : isMobile ? "translate(0.5rem , -3rem)" : "translate(1rem , -4rem)" }} />
                                </div>
                                <div >
                                    <div style={{ position: 'relative', zIndex: 0 }}>
                                        <Typography paragraph fontWeight="bold" fontSize={"27px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                            {getField(dictionary, 'title4', language)}

                                        </Typography>
                                    </div>
                                    <p style={{ fontFamily: "Century Gothic" }}> {getField(dictionary, 'description4', language)}</p>
                                </div>
                                <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                    {getField(dictionary, 'list1', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: "1px", letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc-1', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                    {getField(dictionary, 'list2', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc-2', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                    {getField(dictionary, 'list3', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc-3', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                </List>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-primary)",
                                        color: "white",
                                        marginTop: "30px",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-primary)",
                                        },
                                    }}
                                >  <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                                        {getField(dictionary, 'button3', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <Box display="flex" justifyContent="center">
                                <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about4.png`} loading="lazy" width={isMobile ? 200 : 300} height={isMobile ? 150 : 250} alt="Customer Base" style={{ minWidth: isMobile ? 200 : 300, minHeight: isMobile ? 150 : 250 }} />
                            </Box>
                        </Grid>
                    </Grid>
                </div>
            </div>
            {/* end of section 4 */}


            {/* section 5  */}
            <div className="section-light-purple-bg" style={{ marginTop: "20px" }}>
                <Grid container spacing={isMobile ? 2 : 4} alignItems="center" justifyContent="center" padding={isMobile ? "0px " : "30px"} className="section-light-purple-bg">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "85%", flexDirection: isMobile ? "column" : "row" }}>
                        {!isMobile && (
                            <Grid item xs={12} md={5} >
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about5.png`} loading="lazy" width={isMobile ? 200 : 300} height={isMobile ? 150 : 250} alt="Customer Base" style={{ minWidth: isMobile ? 200 : 300, minHeight: isMobile ? 150 : 250 }} />
                                </Box>
                            </Grid>
                        )}

                        <Grid item xs={12} md={7} >
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <div >
                                    <div style={{ position: 'relative', zIndex: 0 }}>
                                        <Typography paragraph fontWeight="bold" fontSize={"2rem"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                            {getField(dictionary, 'title5', language)}

                                        </Typography>
                                    </div>
                                    <div style={{ position: 'relative', zIndex: -1 }}>
                                        {getSvg('doubleLinesIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 80, height: 20 }, { position: 'absolute', minWidth: 80, minHeight: 20, transform: isArabic ? "translate(-10rem , -1rem)" : "translate(14rem , -1.5rem)" })}
                                    </div>
                                    {/* <p style={{ fontFamily: "Century Gothic" }}>  {getField(dictionary, 'description5', language)}</p> */}
                                </div>
                                <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                    {getField(dictionary, 'list4', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: "1px", letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc4', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>
                                                    {getField(dictionary, 'list5', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc5', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                    {getField(dictionary, 'list6', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc6', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                    {getField(dictionary, 'list7', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc7', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                    {getField(dictionary, 'list8', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc8', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            primary={
                                                <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                    <span style={{ color: 'var(--accent-primary)' }}>&#10004;</span>
                                                    {getField(dictionary, 'list9', language)}
                                                </span>
                                            }
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'list-desc9', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>
                                </List>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-primary)",
                                        color: "white",
                                        marginTop: "30px",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-primary)",
                                        },
                                    }}
                                >  <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                                        {getField(dictionary, 'button2', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>

                        {isMobile && (
                            <Grid item xs={12} md={5} >
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about5.png`} loading="lazy" width={isMobile ? 200 : 300} height={isMobile ? 150 : 250} alt="Customer Base" style={{ minWidth: isMobile ? 200 : 300, minHeight: isMobile ? 150 : 250 }} />
                                </Box>
                            </Grid>
                        )}
                    </div>
                </Grid>
            </div>
            {/* end of section  5 */}


            {/* section 6  */}
            <div style={{ width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ marginTop: "20px" }}>
                    <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"} >
                        <Grid item xs={12} md={7} >
                            <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <div >
                                    <div style={{ position: 'relative', zIndex: 0 }}>
                                        <Typography paragraph fontWeight="bold" fontSize={isMobile ? "20px" : "30px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                            {getField(dictionary, 'title6', language)}
                                        </Typography>
                                    </div>
                                    <div style={{ position: 'relative', zIndex: -1 }}>
                                        {getSvg('arrowCircleIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 100, height: 100 }, { position: 'absolute', minWidth: 100, minHeight: 100, transform: isArabic ? "translate(-5rem , -5rem)" : isMobile ? "translate(2rem , -6rem)" : "translate(4rem , -6rem)" })}
                                    </div>
                                </div>

                                <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                        <ListItemText
                                            secondary={
                                                <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                    {getField(dictionary, 'description6', language)}
                                                </span>
                                            }
                                        />
                                    </ListItem>

                                </List>
                                <Button
                                    variant='contained'
                                    sx={{
                                        backgroundColor: "var(--accent-secondary)",
                                        color: "black",
                                        marginTop: "30px",
                                        transition: 'background-color 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: "var(--accent-primary)",
                                        },
                                    }}
                                >
                                    <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'black', fontSize: '15px' }}>
                                        {getField(dictionary, 'button3', language)}
                                    </a>

                                </Button>
                            </Paper>
                        </Grid>

                        {!isMobile && (
                            <Grid item xs={12} md={5} >
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about6.png`} width="70%" height="auto" alt="Take Control" loading="lazy" />
                                </Box>
                            </Grid>
                        )}

                        {isMobile && (
                            <Grid item xs={12} md={5} >
                                <Box display="flex" justifyContent="center">
                                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/about6.png`} loading="lazy" width="70%" height="auto" alt="Take Control" style={{ maxWidth: '100%', borderRadius: '10px' }} />
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                    <div style={{ marginTop: "4rem", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center' }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    lineHeight: 1,
                                }}
                            >
                                <Typography
                                    fontWeight="bold"
                                    fontSize={isMobile ? "3rem" : "3.5rem"}
                                    sx={{ color: "var(--text-primary)", margin: 0, padding: 0 }}
                                    fontFamily="Century Gothic"
                                >
                                    {getField(dictionary, 'join', language)}
                                </Typography>
                                <Typography
                                    fontWeight="bold"
                                    fontSize={isMobile ? "1.7rem" : "2.5rem"}
                                    color="var(--accent-secondary)"
                                    fontFamily="Century Gothic"
                                    sx={{ margin: 0, padding: 0, transform: 'translate(2rem , -1rem)' }}
                                >
                                    {getField(dictionary, 'us', language)}
                                </Typography>
                            </div>
                            {getSvg('arrowUpIcon', { mainPurple: 'var(--accent-primary)' }, { width: isMobile ? '70px' : '100px', height: isMobile ? '70px' : '100px' }, {
                                    minWidth: isMobile ? 70 : 100,
                                    minHeight: isMobile ? 70 : 100,
                                    transform: "rotate(-90deg)"
                                })}
                        </div>

                        <div style={{ width: isMobile ? "90%" : "75%", fontSize: "20px", fontFamily: "Century Gothic", color: "var(--text-primary)", textAlign: "center" }}>
                            <p>
                                {getField(dictionary, 'join-text', language)}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            {/* end of section  6 */}
        </>
    )
}